// extracted by css-extract-rspack-plugin
export default {"codeContainer":"ZR6b6"};